export const NOTHING = null;
export const PARAMETRES_AFFIXE2 = {
  listeAlpha2CodePaysLimiteAutocompleteGoogle: {
    key: 'ListeAlpha2CodePaysLimiteAutocompleteGoogle',
  },
};
export const DOMAINE = 'Portail';
